"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("../consts");
const is_equal_1 = require("./is_equal");
const is_native_1 = require("./is_native");
const is_plain_object_1 = require("./is_plain_object");
/* HELPERS */
const { assign } = Object;
/* DIFF */
const diff = (a, b, prefix = '') => {
    const added = {}, deleted = {}, updated = {};
    if (is_plain_object_1.default(a) && is_plain_object_1.default(b)) {
        for (const key in a) {
            if (!b.hasOwnProperty(key)) {
                deleted[`${prefix}${prefix ? '.' : ''}${key}`] = a[key];
            }
            else {
                const result = diff(a[key], b[key], `${prefix}${prefix ? '.' : ''}${key}`);
                assign(added, result.added);
                assign(deleted, result.deleted);
                assign(updated, result.updated);
            }
        }
        for (const key in b) {
            if (a.hasOwnProperty(key))
                continue;
            added[`${prefix}${prefix ? '.' : ''}${key}`] = b[key];
        }
    }
    else if (prefix) {
        const constructorA = a && a.constructor, constructorB = b && a.constructor;
        if (!(constructorA && !consts_1.CONSTRUCTORS_SUPPORTED.has(constructorA) && (consts_1.CONSTRUCTORS_UNSUPPORTED.has(constructorA) || !is_native_1.default(constructorA))) && !(constructorB && !consts_1.CONSTRUCTORS_SUPPORTED.has(constructorB) && (consts_1.CONSTRUCTORS_UNSUPPORTED.has(constructorB) || !is_native_1.default(constructorB))) && !is_equal_1.default(a, b)) {
            updated[prefix] = {
                before: a,
                after: b
            };
        }
    }
    return { added, deleted, updated };
};
/* EXPORT */
exports.default = diff;
